module.exports = __webpack_public_path__ + "img/eject-fill.4f804748.svg";